<mat-list class="adf-version-list" *ngIf="!isLoading; else loading_template">
  <mat-list-item
    class="adf-version-list-item"
    *ngFor="let version of extendedVersions; let idx = index"
  >
    <div mat-line id="version-user-icon" class="adf-version-img-container">
      <div
        class="adf-version-user-icon"
        *ngIf="!isPictureDefined(version.entry.modifiedByUser)"
      >
        {{ getUserShortName(version.entry.modifiedByUser.displayName) }}
      </div>
      <div>
        <img
          [alt]="version.entry.modifiedByUser"
          *ngIf="isPictureDefined(version.entry.modifiedByUser)"
          class="adf-people-img"
          [src]="getUserImage(version.entry.modifiedByUser)"
        />
      </div>
    </div>
    <div class="adf-version-contents">
      <div mat-line class="adf-version-title">
        <span *ngIf="idx === 0">{{
          'ADF_VERSION_LIST.LATEST_VERSION' | translate
        }}</span>
        <span *ngIf="idx !== 0">{{
          'ADF_VERSION_LIST.VERSION' | translate
        }}</span>
        <span
          class="adf-version"
          [id]="'adf-version-list-item-version-' + version.entry.id"
          >{{ version.entry.id }}</span
        >
      </div>
      <div
        mat-line
        [id]="'adf-version-list-item-comment-' + version.entry.id"
        class="adf-version-list-item-user"
        title="{{ version.entry.modifiedByUser.displayName }}"
      >
        {{ version.entry.modifiedByUser.displayName }}
      </div>
      <div
        mat-line
        class="adf-version-list-item-date"
        [id]="'adf-version-list-item-date-' + version.entry.id"
      >
        {{ version.entry.modifiedAt | date : 'short' }}
      </div>
      <div
        mat-line
        [id]="'adf-version-list-item-comment-' + version.entry.id"
        class="adf-version-list-item-comment"
        *ngIf="version.entry.versionComment"
        title="{{ version.entry.versionComment }}"
      >
        {{ version.entry.versionComment }}
      </div>
      <div
        mat-line
        [id]="'adf-version-list-item-comment-' + version.entry.id"
        class="adf-version-list-item-comment"
        *ngIf="!version.entry.versionComment"
      >
        {{ 'ADF_VERSION_LIST.ACTIONS.COMMENTS_NOT_AVAILABLE' | translate }}
      </div>
      <div mat-line class="wk-mat-line">
        <span *ngIf="idx === 0">
          <button
            title="{{ 'ADF_VERSION_LIST.UPLOAD_VERSION' | translate }}"
            type="button"
            class="wk-button wk-button-text wk-button-icon-left"
            [id]="'adf-version-list-action-restore-' + version.entry.id"
            (click)="onUploadNewVersion()"
          >
            <span class="wk-icon-upload-line" aria-hidden="true"></span>
            {{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.UPLOAD_BUTTON' | translate }}
          </button>
        </span>
        <span *ngIf="idx !== 0">
          <button
            title="{{ 'ADF_VERSION_LIST.RESTORE_VERSION' | translate }}"
            (click)="restoreVersion(version.entry)"
            [disabled]="!canUpdate()"
            type="button"
            class="wk-button wk-button-text wk-button-icon-left"
            [id]="'adf-version-list-action-restore-' + version.entry.id"
          >
            <span class="wk-icon-clock-back" aria-hidden="true"></span>
            {{ 'ADF_VERSION_LIST.ACTIONS.RESTORE' | translate }}
          </button>
        </span>
        <span *ngIf="allowDownload">
          <button
            title="{{ 'ADF_VERSION_LIST.DOWNLOAD_VERSION' | translate }}"
            type="button"
            class="wk-button wk-button-text wk-button-icon-left"
            [id]="'adf-version-list-action-download-' + version.entry.id"
            (click)="downloadVersion(version.entry.id)"
          >
            <span class="wk-icon-download-line" aria-hidden="true"></span>
            {{ 'ADF_VERSION_LIST.ACTIONS.DOWNLOAD' | translate }}
          </button>
        </span>
        <span>
          <button
            title="{{ 'ADF_VERSION_LIST.COMPARE_VERSION' | translate }}"
            type="button"
            class="wk-button wk-button-text wk-button-icon-left"
            [disabled]="true"
            [id]="'adf-version-list-action-compare-' + version.entry.id"
          >
            <span class="wk-icon-file-compare" aria-hidden="true"></span>
            {{ 'ADF_VERSION_LIST.ACTIONS.COMPARE' | translate }}
          </button>
        </span>
        <div *ngIf="showDownloadZip">
          <span>
          <button type="button"
            class="wk-button wk-button-text wk-button-icon-left"
            (click)="downloadVersionZip(version, version.entry.id)">
            <span class="wk-icon-download-line" aria-hidden="true"></span>
             {{ 'APP.ACTIONS.DOWNLOAD_ZIP' | translate }}
          </button>
        </span>
        <span>
          <button
            type="button"
            class="hidden wk-button wk-button-text wk-button-icon-left"
            title="{{ 'APP.ACTIONS.DOWNLOAD_CITATION_LOGS_TOOLTIP' | translate }}"
            (click)="downloadVersionCitationLogs(version, version.entry.id)"
          >
            <span class="wk-icon-download-line" aria-hidden="true"></span>
            {{ 'APP.ACTIONS.DOWNLOAD_CITATION_LOGS' | translate }}
          </button>
        </span>
        </div>
      </div>
    </div>
  </mat-list-item>
</mat-list>

<ng-template #loading_template>
  <mat-progress-bar
    data-automation-id="version-history-loading-bar"
    mode="indeterminate"
    color="accent"
  >
  </mat-progress-bar>
</ng-template>
